import { i18n } from '@/lib/i18n'

/** Phần thuần của nút "Nhắn tin" ở hồ sơ khách: chọn đi thẳng vào hội thoại hay phải chọn kênh. */
export interface ContactThread {
  id: string
  lastMessageAt: string | null
  channelAccount: { id: string; displayName: string | null } | null
}

export interface ChannelThread {
  conversationId: string
  accountId: string
  accountName: string
  lastAt: string | null
}

export type MessagePlan =
  | { kind: 'direct'; conversationId: string }
  | { kind: 'choose'; threads: ChannelThread[] }
  | { kind: 'none' }

/** Mỗi kênh (tài khoản) giữ hội thoại mới nhất; mới nhất xếp trước. */
export function threadsByChannel(conversations: ContactThread[]): ChannelThread[] {
  const best = new Map<string, ChannelThread>()
  for (const c of conversations) {
    const a = c.channelAccount
    if (!a) continue
    const cur = best.get(a.id)
    if (!cur || (c.lastMessageAt ?? '') > (cur.lastAt ?? '')) {
      best.set(a.id, { conversationId: c.id, accountId: a.id, accountName: a.displayName ?? i18n.t('custList:messageContact.channel'), lastAt: c.lastMessageAt })
    }
  }
  return [...best.values()].sort((x, y) => (y.lastAt ?? '').localeCompare(x.lastAt ?? ''))
}

/** Một kênh → vào thẳng; nhiều kênh → chọn kênh; chưa có hội thoại nào → chọn kênh để bắt đầu. */
export function planMessage(conversations: ContactThread[]): MessagePlan {
  const threads = threadsByChannel(conversations)
  if (threads.length === 0) return { kind: 'none' }
  if (threads.length === 1) return { kind: 'direct', conversationId: threads[0].conversationId }
  return { kind: 'choose', threads }
}
